module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeSlots m-b-2"
  }, [(_vm.loading) ? _c('div', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.times.length === 0 && typeof _vm.selectedTimeIndex !== 'undefined') ? _c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n    " + _vm._s(_vm.t('This day is fully booked')) + "\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.times.length) ? _c('div', {
    staticClass: "text-xs-center"
  }, [(_vm.times.length > 1) ? _c('span', [_vm._v(_vm._s(_vm.t('Available times for')))]) : _c('span', [_vm._v(_vm._s(_vm.t('Available time for')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.humanDate(_vm.selectedDay)))]), _vm._v(":\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center m-t-1"
  }, _vm._l((_vm.times), function(time, index) {
    return _c('span', [_c('button', {
      staticClass: "btn btn-sm",
      class: {
        'btn-primary': (index === _vm.selectedTimeIndex), 'btn-outline-primary': (index !== _vm.selectedTimeIndex)
      },
      on: {
        "click": function($event) {
          _vm.setSelectedTimeIndex(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.humanTime(time.date)))])])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6b1bb392", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b1bb392"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/TimeSlots.vue
// module id = 785
// module chunks = 3